import React from "react";
import { Breadcrumb } from "gatsby-plugin-breadcrumb";
import { useStaticQuery, graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";
import { PageHeaderWrap } from './page-header.style';

const PageHeader = ({ pageContext, location, title, customLabel  }) => {
	const { breadcrumb: { crumbs } } = pageContext;
	const disableLinks = [
		"/elements",
		"/category",
		"/profile",
		"/date",
		"/tag",
		"/page",
		"/blog",
		"/blog/page",
		"/blogs",
		"/services"
	]
	const customCrumbLabel = location.pathname.toLowerCase();
	const crumbLabelArr = customCrumbLabel.split('/');
	const label = crumbLabelArr[crumbLabelArr.length - 1]	
	const labelArr = label.split('-')
	const imageData = useStaticQuery(graphql`
        query breadCrumbImgQueryAndBreadCrumbImgQuery  {
            file(relativePath: {eq: "images/bg/mitech-slider-cybersecurity-global-image.png"}) {
                childImageSharp {
					gatsbyImageData(
						layout: FULL_WIDTH
						placeholder: TRACED_SVG
						formats: WEBP
						quality: 100
					)
                }
            }
        }
      
    `);
	const bgImage = convertToBgImage(getImage(imageData.file))
	return (
		<PageHeaderWrap {...bgImage}>
			<Breadcrumb style ={{color:"#ffffff !important"}}
				title={title}
				crumbs={crumbs}
				crumbLabel={customLabel}
				disableLinks={disableLinks}
			/>
		</PageHeaderWrap>
	)
}

export default PageHeader
